module.exports = __webpack_public_path__ + "1792395595471/images/fa-brands-400.83e6c29.svg";